// Canonical wiring helper: post a wizard's inline NoteComposer draft AFTER
// the entity create/update succeeds. FR-1 invariant: note failure never rolls
// back the entity — callers surface a warning toast and direct the user to
// the audit-trail panel for a manual re-add.
import { addNote, Note } from "@services/notes";
import { DBTables } from "@utils/constants/dbTables";

import { DraftNote, isEmptyDraftNote } from "./NoteComposer";

export type FlushResult =
  | { kind: "posted"; note: Note }
  | { kind: "failed"; error: unknown }
  | { kind: "skipped" };

export async function flushNoteStepDraft(
  draft: DraftNote | null | undefined,
  referenceTable: DBTables,
  referenceId: string,
): Promise<FlushResult> {
  if (isEmptyDraftNote(draft) || !draft) {
    return { kind: "skipped" };
  }
  try {
    const note = await addNote({
      referenceTable,
      referenceId,
      note: draft.body,
      isReportable: draft.isReportable,
      attachment: draft.attachment,
    });
    return { kind: "posted", note };
  } catch (error) {
    return { kind: "failed", error };
  }
}
